import { styleOverrides } from "./styleOverrides";

const MuiDialog = {
  styleOverrides,
};

export { MuiDialog };
